import { createTheme, darken, lighten } from '@material-ui/core/styles'; // view colorManipulator functions from MUI here: https://github.com/mui/material-ui/blob/v4.x/packages/material-ui/src/styles/colorManipulator.js
import grey from '@material-ui/core/colors/grey';
import type { Theme, ThemeOptions } from '@material-ui/core/styles/createTheme';

import { getDefaultClassOverrides } from 'themes/getTheme/defaultTheme';

const { palette: lifepointPalette } = createTheme({
  palette: {
    contrastThreshold: 4.5, // AA a11y standards for text contrast ratio

    /* **** Main MUI Colors **** */
    primary: {
      main: '#306CB4',
    },
    secondary: {
      main: '#764A9D',
    },
    info: {
      main: '#764A9D',
    },
    success: {
      main: '#1C988C',
    },
    warning: {
      main: '#C34515',
    },
    error: {
      main: '#D73737',
    },

    /* **** Custom Colors **** */
    tertiary: {
      light: '#5989c3',
      main: '#306CB4',
      dark: '#214b7d',
      contrastText: '#FFFFFF',
    },

    rewards: {
      main: '#9F52CE',
      light: '#B275D8',
      dark: '#722C9D',
      contrastText: '#FFFFFF',
    },

    text: {
      secondary: grey[700],
    },

    focusIndicator: '#764A9D',

    scoreTier: {
      1: '#1C988C',
      2: '#764A9D',
      3: '#212121',
    },
  },
});

function getLifepointClassOverrides(
  palette: Theme['palette'] = lifepointPalette
): ThemeOptions['overrides'] {
  const defaultClassOverrides = getDefaultClassOverrides(palette);

  return {
    ...defaultClassOverrides,
    MuiTypography: {
      colorSecondary: {
        color: palette.primary.dark,
      },
    },
    MuiButton: {
      ...defaultClassOverrides?.MuiButton,

      containedSecondary: {
        ...defaultClassOverrides?.MuiButton?.containedSecondary,

        // there are some specific buttons for lifepoint that we want to override from containedSecondary to containedPrimary (result card details)
        // for any button in the app that is marked as secondary but needs to flip to primary, give it a className and add that className in the selector below
        '&.card-details-button': {
          ...defaultClassOverrides?.MuiButton?.containedPrimary,
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          '&:hover': {
            backgroundColor: palette.primary.dark,
          },

          '&$focusVisible': {
            outlineColor: lighten(palette.primary.main, 0.15),
            backgroundColor: darken(palette.primary.main, 0.3),
          },
        },
      },
    },
  };
}

const lifepointThemeVariant: ThemeOptions = {
  palette: lifepointPalette,
  overrides: getLifepointClassOverrides(),
  props: {},
  typography: {},
};

export default lifepointThemeVariant;
